import clsx from 'clsx';
import IconifyIcon from '../wrappers/IconifyIcon';

const WhatsAppToast = ({ toast, onClose }) => {
  if (!toast) return null;
  return (
    <div
      className={clsx(
        'position-fixed top-0 start-50 translate-middle-x mt-3 alert shadow alert-dismissible',
        `alert-${toast.type}`,
      )}
      role="alert"
      style={{ zIndex: 9999, minWidth: 300 }}
    >
      <IconifyIcon
        icon={toast.type === 'success' ? 'bx:check-circle' : 'bx:error-circle'}
        className="me-2 fs-18 align-middle"
      />
      {toast.message}
      <button type="button" className="btn-close" onClick={onClose} />
    </div>
  );
};

export default WhatsAppToast;
